/**
 * Minimal typed i18n. No runtime dependency, no async loading, no fallback
 * chain to get lost in. es-MX is the shipping locale; the others are
 * scaffolded so adding a language is a translation job, not a code change.
 *
 * The rule for every package: no user-visible string is written inline. If it
 * appears on a screen or on paper, its key lives here.
 */
import { esMX } from './es-MX.js';
import { enUS } from './en-US.js';
export const SUPPORTED_LOCALES = ['es-MX', 'en-US', 'fr-FR', 'it-IT'];
export const DEFAULT_LOCALE = 'es-MX';
const catalogs = {
    'es-MX': esMX,
    'en-US': enUS,
    'fr-FR': {},
    'it-IT': {},
};
export function isLocale(value) {
    return SUPPORTED_LOCALES.includes(value);
}
/**
 * Returns a translator bound to a locale. Missing keys fall back to es-MX
 * rather than rendering the raw key, because a half-translated screen is
 * better than a screen showing `sale.confirm.title` to a cashier.
 */
export function translator(locale = DEFAULT_LOCALE) {
    const primary = catalogs[locale] ?? {};
    return function t(key, vars) {
        const template = (primary[key] ?? esMX[key] ?? key);
        if (!vars)
            return template;
        return template.replace(/\{(\w+)\}/g, (match, name) => name in vars ? String(vars[name]) : match);
    };
}
export { esMX, enUS };
//# sourceMappingURL=index.js.map